import React, {useEffect, useRef, useState} from 'react';
import {IconEdit, IconMoreVertical, IconTrash} from '../../../shared/components/HosannaIcons';

// Hosanna's overflow: rarely used song actions hide behind the vertical dots.
export default function SongActionsMenu({title, onEdit, onDelete}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = event => {
      if (event.type === 'keydown' ? event.key === 'Escape' : !rootRef.current?.contains(event.target)) setOpen(false);
    };
    window.addEventListener('pointerdown', close);
    window.addEventListener('keydown', close);
    return () => {window.removeEventListener('pointerdown', close); window.removeEventListener('keydown', close);};
  }, [open]);
  if (!onEdit && !onDelete) return null;
  const run = action => event => {event.stopPropagation(); setOpen(false); action(event);};
  return <div className="song-actions-menu" ref={rootRef} onClick={event => event.stopPropagation()}>
    <button type="button" className="song-header-action song-header-action--more" aria-haspopup="menu" aria-expanded={open}
      aria-label={`Więcej akcji dla pieśni ${title}`} title={`Więcej akcji dla pieśni ${title}`}
      onClick={() => setOpen(value => !value)}><IconMoreVertical/></button>
    {open && <div className="song-actions-menu-list" role="menu" aria-label={`Akcje pieśni ${title}`}>
      {onEdit && <button type="button" role="menuitem" className="song-actions-menu-item" aria-label={`Edytuj pieśń: ${title}`}
        title="Edytuj tę pieśń" onClick={run(onEdit)}><IconEdit/><span>Edytuj</span></button>}
      {onDelete && <button type="button" role="menuitem" className="song-actions-menu-item song-actions-menu-item--danger"
        title="Usuń piosenkę" onClick={run(onDelete)}><IconTrash/><span>Usuń</span></button>}
    </div>}
  </div>;
}
